import api from '../../config/axios.js';
import moment from 'moment';

let recordingCamerasRequestId = 0;

const state = {
    cameras: [],
    camerasForClient: [],
    recordingCameras: [],
    recordingCamerasPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 7,
        total: 0,
        from: null,
        to: null,
    },
    recordingCameraFilters: {
        clients: [],
        storage_days: [],
        qualities: [],
    },
    currentCamera: {},
    currentSearchCamera: {},
    manufacturers: []
}
const getters = {
    getCameras: state => state.cameras,
    getCamerasForClient: state => state.camerasForClient,
    getRecordingCameras: state => state.recordingCameras,
    getRecordingCamerasPagination: state => state.recordingCamerasPagination,
    getRecordingCameraFilters: state => state.recordingCameraFilters,
    getCurrentCamera: state => state.currentCamera,
    getCurrentSearchCamera: state => state.currentSearchCamera,
    getManufacturers: state => state.manufacturers,
}
const actions = {
    resetCamerasByCompanyId({commit}){
        commit('resetCamerasByCompanyId');
    },
    // LISTANDO AS CAMERAS DE ACORDO COM O COMPANY_ID
    async setCamerasByCompanyId({ commit }, id){
        await api.axios.get('/api/list/camera/'+id).then(function(response){
            if(response.status == 200){
                commit('setCamerasByCompanyId', response.data);
            }
        });
    },
    // LISTANDO AS CAMERAS DISPONÍVEL PARA O CLIENTE
    async setCurrentSearchCamera({ commit }, params){
            await api.axios.get('/api/search/camera', params).then(function(response){
                if(response.status == 200){
                    commit('setCurrentSearchCamera', response.data);
                }
            });
    },
    // LISTANDO AS CAMERAS DISPONÍVEL PARA O CLIENTE
    async setCamerasForClient({ commit }){
        await api.axios.get('/api/list/cameras').then(function(response){
            if(response.status == 200){
                commit('setCamerasForClient', response.data);
            }
        });
    },
    // LISTANDO AS CAMERAS PAGINADAS PARA A TELA DE GRAVACOES
    async setRecordingCameras({ commit }, params = {}){
        const requestId = ++recordingCamerasRequestId;
        commit('resetRecordingCameras');
        const response = await api.axios.get('/api/list/recording-cameras', { params });

        if(response.status == 200 && requestId === recordingCamerasRequestId){
            commit('setRecordingCameras', response.data);
        }
    },
    // LISTANDO OS FABRICANTES DE CÂMERAS
    async setManufacturers({ commit }){
        await api.axios.get('/api/list/manufacturer').then(function(response){
            if(response.status == 200){
                console.log("bateu aqui certinhooo");
                commit('setManufacturers', response.data);
            }
        });
    },
    // SETANDO A CÂMERA ATUAL DO CLIENTE NO MODAL
    async setCurrentCamera({ commit }, data){
        commit('setCurrentCamera', data);
    },
    updateCameraAiMonitoringRegion({ commit }, data){
        commit('updateCameraAiMonitoringRegion', data);
    },
}
const mutations = {
    // RESETANDO CAMERAS
        resetCamerasByCompanyId: function(state){
            state.cameras = [];
        },
    // SETANDO CAMERAS DA COMPANY_ID
        setCamerasByCompanyId: function(state, data){
            if(data.length > 0){
                data.forEach(element => {
                    element.created_at = moment(element.created_at).format('HH:mm:ss - DD/MM/YYYY')
                });
            }
            state.cameras = data;
        },
    // SETANDO CAMERA DA PESQUISA
        setCurrentSearchCamera: function(state, data){
            state.currentSearchCamera = data;
        },
    // SETANDO CAMERAS POR CLIENTE
    setCamerasForClient: function(state, data){
        state.camerasForClient = data;
    },
    // SETANDO CAMERAS E METADADOS DA PAGINACAO DE GRAVACOES
    setRecordingCameras: function(state, data){
        state.recordingCameras = data.data || [];
        state.recordingCamerasPagination = {
            current_page: data.current_page || 1,
            last_page: data.last_page || 1,
            per_page: data.per_page || 7,
            total: data.total || 0,
            from: data.from || null,
            to: data.to || null,
        };
        if(data.filters){
            state.recordingCameraFilters = data.filters;
        }
    },
    resetRecordingCameras: function(state){
        state.recordingCameras = [];
        state.recordingCamerasPagination = {
            current_page: 1,
            last_page: 1,
            per_page: 7,
            total: 0,
            from: null,
            to: null,
        };
    },
    // SETANDO A CAMERA ATUAL DO CLIENTE
    setCurrentCamera: function(state, data){
        state.currentCamera = data;
    },
    updateCameraAiMonitoringRegion: function(state, data){
        const camera = state.cameras.find(item => Number(item.id) === Number(data.cameraId));
        if(camera){
            camera.ai_monitoring_region = data.region;
        }
        if(state.currentCamera && Number(state.currentCamera.id) === Number(data.cameraId)){
            state.currentCamera.ai_monitoring_region = data.region;
        }
    },
    // SETANDO A LISTA DE FABRICANTES
        setManufacturers: function(state, data){
            console.log("setManufacturers", data);
            state.manufacturers = data;
        }
}
export default {
    state,
    getters,
    actions,
    mutations
}
